import { LayoutBlock } from '@/layout';
import { RouteConfig } from 'vue-router';

const UnderlyingRouting: RouteConfig[] = [
    {
        path: 'underlying-data',
        meta: { title: '基础数据' },
        component: LayoutBlock,
        redirect: '/app/underlying-data/the-progress-of-the-problem',
        children: [
            {
                name: 'the-progress-of-the-problem',
                path: 'the-progress-of-the-problem',
                component: () => import('./the-progress-of-the-problem/the-progress-of-the-problem.vue'),
                meta: { title: '问题进度' },
            },
            {
                name: 'problem-classification',
                path: 'problem-classification',
                component: () => import('./problem-classification/problem-classification.vue'),
                meta: { title: '问题分类' },
            },
            {
                name: 'audit-point',
                path: 'audit-point',
                component: () => import('./audit-point/audit-point.vue'),
                meta: { title: '审核点' },
            },
            {
                name: 'audit-items',
                path: 'audit-items',
                component: () => import('./audit-items/audit-items.vue'),
                meta: { title: '审核项' },
            },
            {
                name: 'the-type-of-audit-item',
                path: 'the-type-of-audit-item',
                component: () => import('./the-type-of-audit-item/the-type-of-audit-item.vue'),
                meta: { title: '审核项类型' },
            },
            {
                name: 'audit-level',
                path: 'audit-level',
                component: () => import('./audit-level/audit-level.vue'),
                meta: { title: '审核层级' },
            },
            // {
            //     name: 'organization-structure',
            //     path: 'organization-structure',
            //     component:()=>import('./organization-structure/organization-structure.vue'),
            //     meta: { title: '审核模板' },
            // },
            {
                name: 'new-structure',
                path: 'new-structure',
                component: () => import('./new-structure/new-structure.vue'),
                meta: { title: '组织架构' },
            },
            {
                name: 'layoutUser',
                path: 'layoutUser',
                component: () => import('./layoutUser/layoutUser.vue'),
                meta: { title: 'LPA用户' },
            },
            {
                name: 'organization-structure',
                path: 'organization-structure',
                component: () => import('./organization-structure/organization-structure.vue'),
                meta: { title: '审核点模板' },
            },
            {
                name: 'audit-task',
                path: 'audit-task',
                component: () => import('./audit-task/audit-task.vue'),
                meta: { title: '审核计划' },
            },
            {
                name: 'audittaskdetail',
                path: 'audittaskdetail',
                component: () => import('./audittaskdetail/audittaskdetail.vue'),
                meta: { title: '审核记录' },
            },
            {
                name: 'problem-management',
                path: 'problem-management',
                component: () => import('./problem-management/problem-management.vue'),
                meta: { title: '问题管理' },
            },
            {
                name: 'audit-item-templates',
                path: 'audit-item-templates',
                component: () => import('./audit-item-templates/audit-item-templates.vue'),
                meta: { title: '审核项模板' },
            },
            {
                name: 'issueKanban',
                path: 'issueKanban',
                component: () => import('./issueKanban/issueKanban.vue'),
                meta: { title: '问题看板' },
            },
            {
                name: 'punch-card-records',
                path: 'punch-card-records',
                component: () => import('./punch-card-records/punch-card-records.vue'),
                meta: { title: '点位打卡月视图' },
            },
            {
                name: 'month-view',
                path: 'month-view',
                component: () => import('./month-view/month-view.vue'),
                meta: { title: '点位打卡记录' },
            },
            {
                name: 'Mail-configuration',
                path: 'Mail-configuration',
                component: () => import('./Mail-configuration/Mail-configuration.vue'),
                meta: { title: '邮件配置' },
            },
            {
                name: 'Line-chart',
                path: 'Line-chart',
                component: () => import('./Line-chart/Line-chart.vue'),
                meta: { title: '点位审核次数统计' },
            },
            {
                name: 'Message-push',
                path: 'Message-push',
                component: () => import('./Message-push/Message-push.vue'),
                meta: { title: '消息推送' },
            },
            {
                name: 'issue-reports',
                path: 'issue-reports',
                component: () => import('./issue-reports/issue-reports.vue'),
                meta: { title: '问题报表' },
            },
            {
                name: 'month-view-emp',
                path: 'report/month-view-emp',
                component: () => import('./report/month-view-emp/month-view-emp.vue'),
                meta: { title: '员工月视图' },
            }, {
                name: 'month-view-auditteam',
                path: 'report/month-view-auditteam',
                component: () => import('./report/month-view-auditteam/month-view-auditteam.vue'),
                meta: { title: '审核团队月视图' },
            },
            {
                name: 'issue-config',
                path: 'issue-config',
                component: () => import('./issue-config/issue-config.vue'),
                meta: { title: '设置' },
            },
            {
                name: 'AuditResultSummary_Report',
                path: 'AuditResultSummary_Report',
                component: () => import('./AuditResultSummary_Report/AuditResultSummary_Report.vue'),
                meta: { title: '审核结果汇总' },
            },
            {
                name: 'report-audit-point-record',
                path: 'report/audit-point-record',
                component: () => import('./report/audit-point-record/audit-point-record.vue'),
                meta: { title: '审核点记录统计' },
            },
            {
                name: 'report-user-audit-record',
                path: 'report/user-audit-record',
                component: () => import('./report/user-audit-record/user-audit-record.vue'),
                meta: { title: '人员审核记录统计' },
            },
            {
                name: 'option-list',
                path: 'option-list',
                component: () => import('./option-list/option-list.vue'),
                meta: { title: '选项列表' },
            },
            {
                name: 'spot-check',
                path: 'spot-check',
                component: () => import('./audit-task/spot-check/spot-check.vue'),
                meta: { title: '抽检' },
            },
            {
                name: 'AuditItemIssueStatistics',
                path: 'AuditItemIssueStatistics',
                component: () => import('./AuditItemIssueStatistics/AuditItemIssueStatistics.vue'),
                meta: { title: '审核项问题统计' },
            },
            {
                name: 'audit-task-report',
                path: 'audit-task-report',
                component: () => import('./audit-task-report/audit-task-report.vue'),
                meta: { title: 'audit-task-report' },
            },
            {
                name: 'audit-item-issues-report',
                path: 'audit-item-issues-report',
                component: () => import('./audit-item-issues-report/audit-item-issues-report.vue'),
                meta: { title: 'audit-item-issues-report' },
            },
            {
                name: 'barcode',
                path: 'barcode',
                component: () => import('./barcode/barcode.vue'),
                meta: { title: 'barcode' },
            },
            {
                name: 'Text-Message',
                path: 'Text-Message',
                component: () => import('./Text-Message/Text-Message.vue'),
                meta: { title: '短信推送' },
            },
            {
                name: 'WeCom-Message',
                path: 'WeCom-Message',
                component: () => import('./WeCom-Message/WeCom-Message.vue'),
                meta: { title: '企业微信推送' },
            },
//             {
//                 name: 'DingTalk-Message',
//                 path: 'DingTalk-Message',
//                 component: () => import('./DingTalk-Message/DingTalk-Message.vue'),
//                 meta: { title: '钉钉推送' },
//             },
            {
                name: 'issue-assistant-confirm',
                path: 'issue-assistant-confirm',
                component: () => import('./issue-assistant-confirm/issue-assistant-confirm.vue'),
                meta: { title: '问题助手确认' },
            },
            {
                name: 'audit-team',
                path: 'audit-team',
                component: () => import('./audit-team/audit-team.vue'),
                meta: { title: '审核团队管理' },
            },
        ],
    },
];
export default UnderlyingRouting;
